import Stack from "react-bootstrap/Stack";
import Form from "react-bootstrap/Form";
import InputMask from "react-input-mask";
import Button from "react-bootstrap/Button";
import {getFormData} from "services/FormFunctions"
import {CriarProcessoVazio} from "services/CallAPIs"
import { useNavigate } from "react-router-dom";
import * as Links from "constants/links"
import Card from 'react-bootstrap/Card';

import { formatDate } from "services/FormFunctions"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function ElementoProcesso({headText, labelText, buttonName, buttonText, onSubmit})
{
    return(
        <Stack gap={3}>
            <h2 className="text-center text-primary">{headText}</h2>
            <Form onSubmit={onSubmit}>
                <Form.Group className="d-flex flex-column justify-content-center mb-3" controlId="form">
                    <Form.Label className="mx-auto">{labelText}</Form.Label>
                    <Form.Control 
                        type="text" 
                        as={InputMask}
                        mask="99.999/9999"
                        placeholder="00.000/20XX"
                        name={buttonName}
                        className="w-auto mx-auto"/>
                </Form.Group>
                <div className="d-flex justify-content-center">
                    <Button variant="primary" type="submit">
                        {buttonText}
                    </Button>
                </div>
            </Form>
        </Stack>
    )
}

export function IniciarOuContinuarProcessoScreen()
{
    const navigate = useNavigate()
    function SubmitCriarProcesso(event)
    {
        event.preventDefault()
        const form = event.currentTarget
        const data = getFormData(form)
        console.log(data)
        // console.log(CriarProcessoVazio(data["numProcStr"]))
        navigate(Links.PROCESSO_SERVICOS)
    }

    return(
        <Stack direction="horizontal" className="mx-auto my-auto" gap={5}>
            <ElementoProcesso 
                headText={"Ainda não abriu o processo?"} 
                labelText={"Digite o número do processo a ser criado"} 
                buttonText={"Criar processo"}
                buttonName={"numProcStr"}
                onSubmit={SubmitCriarProcesso} />
            <ElementoProcesso 
                headText={"Já abriu o processo?"} 
                labelText={"Digite o número do processo para dar continuidade"} 
                buttonText={"Buscar processo"}
                onSubmit={undefined} />
        </Stack>
    )
}